export default {
  assumptionCostingList: {
    method: 'post',
    url: '/client/costing/assumption-driver/list'
  },
  createAssumptionDriver: {
    method: 'post',
    url: '/client/costing/assumption-driver/create'
  },
  editAssumptionDriver: {
    method: 'put',
    url: '/client/costing/assumption-driver/update/ID'
  },
  getDetailAssumptionDriver: {
    method: 'get',
    url: '/client/costing/assumption-driver/detail/ID'
  },
  deleteAssumptionDriver: {
    method: 'delete',
    url: '/client/costing/assumption-driver/delete/ID'
  },
  getAll: {
    method: 'get',
    url: '/client/costing/assumption-driver/all'
  },
  archiveGasoline: {
    method: 'delete',
    url: '/client/costing/assumption-driver/archive'
  },
  restoreGasoline: {
    method: 'put',
    url: '/client/costing/assumption-driver/restore'
  }
}
